import {
  convertPostsWithValidTreeToSingularitySectionLibrary,
  getPostsWithValidTreeFromRemote
} from "./library";
import { setSingularitySectionLibrary } from "./library-singleton";
import { maybePopulateCurrentDocumentFromPageDescription } from "./singularity";

export function addListenersForSingularityToPopulatePageWithLibrarySections() {
  // Breakdance actions logic adds listeners twice... registerStoreActions is called twice.
  window.removeEventListener(
    "breakdance_document_ready",
    handleBreakdanceDocumentReady
  );
  window.addEventListener(
    "breakdance_document_ready",
    handleBreakdanceDocumentReady
  );
}

async function handleBreakdanceDocumentReady() {
  if (window.Breakdance.singularity) {
    // todo - this should probably use the mode in uiStore set by uiStore.setMode 
    // todo - loadSingularitySectionLibrary should happen elsewhere, probably long before document is ready. it should probably happen when the editor is loaded.
    const success = await loadSingularitySectionLibrary();

    if (success) {
      maybePopulateCurrentDocumentFromPageDescription();
    }
  }
}

export async function loadSingularitySectionLibrary() {
  const posts = await getPostsWithValidTreeFromRemote();

  if (!posts) {
    alert("getPostsWithValidTreeFromRemote failed");
    console.log("getPostsWithValidTreeFromRemote failed");
    return false;
  }

  const singularitySectionLibrary =
    convertPostsWithValidTreeToSingularitySectionLibrary(posts);
  setSingularitySectionLibrary(singularitySectionLibrary);

  return true;
}
